// DynamicSlider.js
import React from 'react';
import Slider from 'react-slick';
import { Container, Row, Col } from 'react-bootstrap';


const DynamicSlider = ({ sliderItems }) => {
  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1
          }
        },
        {
          breakpoint: 700,
          settings: {
            slidesToShow:1,
            slidesToScroll: 1
          }
        }
      ]
  };

  

  return (

    <div>        
    <section className='whoslider pt-0'>
      <Container>
        <Row>
          <Col lg={12}>
    <Slider {...settings}>
      {sliderItems.map((item, index) => (
        <div key={index}>
          <div>           
          <img src={item.image} alt={item.alt} />
          {/* <h3>{item.title}</h3>
          <p>{item.description}</p> */}
          </div>
         
        </div>
      ))}
    </Slider>
    


    </Col>
          </Row>
        </Container>
      </section>
      
    </div>
  );
}

export default DynamicSlider;
